export default __webpack_public_path__ + "static/gurumurthy-sithuraj-10a4923390b6e36ceabb62b000c773aa.png";